import { ProfileEditor } from "@/element/profile-editor"

export default function ProfileSettings() {
  return <ProfileEditor onClose={() => {}} />
}
